import {createReducer} from "redux-act";
import {fetchConstructorsJSONSuccess} from "modules/actions";
import {IDictionary} from "modules/types";

export interface IConstructorStatsEvent {
	points: number;
	highest_position: number;
}

export interface IConstructorStats {
	cost: number;
	prices: IDictionary<number>;
	events: IDictionary<IConstructorStatsEvent>;
	podiums: number;
	fastest_lap: number;
	race_time: number;
	total_points: number;
	avg_grid_pos: number;
	avg_finishing_pos: number;
	total_gp_points: number;
	total_fantasy_points: number;
	num_riders: number;
	price_diff: number;
}

export interface IConstructor {
	id: number;
	name: string;
	cost: number;
	num_riders: number;
	stats: IConstructorStats;
}

const defaultState: IConstructor[] = [];

export const constructors = createReducer<typeof defaultState>({}, defaultState).on(
	fetchConstructorsJSONSuccess,
	(_state, payload) => payload
);
